type PreviewImagePosition =
  | 'top_left'
  | 'top_center'
  | 'top_right'
  | 'center_left'
  | 'center'
  | 'center_right'
  | 'bottom_left'
  | 'bottom_center'
  | 'bottom_right';

const DEFAULT_OBJECT_POSITION = 'center';

const OBJECT_POSITION_BY_PREVIEW: Record<PreviewImagePosition, string> = {
  top_left: 'left top',
  top_center: 'center top',
  top_right: 'right top',
  center_left: 'left center',
  center: 'center',
  center_right: 'right center',
  bottom_left: 'left bottom',
  bottom_center: 'center bottom',
  bottom_right: 'right bottom'
};

const isPreviewImagePosition = (
  value: unknown
): value is PreviewImagePosition => {
  if (typeof value !== 'string') return false;
  return value in OBJECT_POSITION_BY_PREVIEW;
};

export const toObjectPosition = (position: unknown): string => {
  if (!isPreviewImagePosition(position)) return DEFAULT_OBJECT_POSITION;
  return OBJECT_POSITION_BY_PREVIEW[position];
};
